module.exports = __webpack_public_path__ + "img/suit (5).c60db29a.png";